import DateTimePicker from '@ui-components-3/ui/lib/components/DateTimePicker'
import Placeholder from 'components/Dashboard/common/Placeholder'
import { observer, Observer } from 'mobx-react-lite'
import User from 'singletons/User'
import { format } from 'date-fns'
import { useCallback, useMemo } from 'react'
import PaymentsAlert from './components/PaymentsAlert'
import useTable from '@ui-components-3/ui/lib/components/Table/hooks/useTable'
import CommonTable from 'components/common/tables/CommonTable/CommonTable'
import FileArrowDownIcon from '@ui-components-3/icons/lib/solid/FileArrowDown'

const DateInput = ({ value, onChange }) => <DateTimePicker onChange={onChange} autoComplete="off" value={value} />

const Payments = () => {
  const { payments } = User.provider

  const { filteredList, isDownloading, list } = payments || {}

  const onDownloadClick = useCallback(
    (payment) => () => {
      if (!payment) return

      const { providerPaymentId, year, month } = payment
      payments.downloadPayment(providerPaymentId, year, month)
    },
    [payments],
  )

  const columns = useMemo(
    () => [
      {
        accessorKey: 'createdAt',
        cell: (cell) => {
          const { year, month } = cell?.row?.original || {}

          if (!year) return ''

          return format(new Date(year, month - 1), 'MMMM yyyy')
        },
        header: 'Date',
        enableSorting: true,
        meta: {
          cellClassName: 'sm:w-[250px]',
        },
      },
      {
        id: 'total',
        accessorFn: (row) => `$${row.total}`,
        header: 'Amount',
        enableSorting: true,
      },
      {
        id: 'actions',
        header: '',
        cell: (cell) => {
          return (
            <button
              type="button"
              className="btn-md btn-primary-borderless"
              onClick={onDownloadClick(cell?.row?.original)}
              disabled={!!isDownloading}
              aria-label="Download"
            >
              <FileArrowDownIcon aria-hidden="true" />
            </button>
          )
        },
        meta: {
          cellClassName: 'w-[60px]',
        },
      },
    ],
    [isDownloading, onDownloadClick],
  )

  const table = useTable({
    paginationType: 'client',
    columns,
    data: filteredList || [],
    rowId: 'total',
  })

  return (
    <div>
      {list.length ? (
        <div className="p-8 flex flex-col gap-4">
          <PaymentsAlert />
          <h4 className="typography-body-xl font-medium text-primary-800">Shift Coverage Payments</h4>
          <div className="flex gap-8 mt-3 flex-wrap">
            <div>
              <p className="typography-body font-medium text-neutral-600">Start Date</p>
              <Observer>
                {() => <DateInput value={payments.filter.startDate} onChange={payments.setStartDate} />}
              </Observer>
            </div>
            <div>
              <p className="typography-body font-medium text-neutral-600">End Date</p>
              <Observer>{() => <DateInput value={payments.filter.endDate} onChange={payments.setEndDate} />}</Observer>
            </div>
          </div>
          <CommonTable
            model={table}
            aria-label="Payments Table"
            className="w-full typography-body font-medium"
            containerClassName="!min-h-max !basis-auto"
          />
        </div>
      ) : (
        <Placeholder text="No Payments Found" icon="" />
      )}
    </div>
  )
}

export default observer(Payments)
